export const ERROR_ROUTE_PARAMETRIZED = 'blad/:errorStatus';
export const ERROR_ROUTE = 'blad';
